import VmpDocDlglist from './src/main';

VmpDocDlglist.install = function (Vue) {
  Vue.component(VmpDocDlglist.name, VmpDocDlglist);
};

export default VmpDocDlglist;
